export default function LieuxConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('profils');
}

LieuxConfiguration.$inject = ['$translatePartialLoaderProvider'];
